import type { ReturnSteps, ReturnStep } from '../types/returns';

export const RETURN_STEP_PACK_ITEMS = 'packItems';
export const RETURN_STEP_RETURN_LABEL = 'returnLabel';
export const RETURN_STEP_CONTACT_US = 'contactUs';
export const RETURN_STEP_SEND_PARCEL = 'sendParcel';
export const RETURN_STEP_REFUND = 'refund';

export const FETCH_RETURNED_ORDER_SUCCESS = 'FETCH_RETURNED_ORDER_SUCCESS';
export const RESET_RETURNED_ORDER = 'RESET_RETURNED_ORDER';

export const returnSteps: ReturnSteps = {
    [RETURN_STEP_PACK_ITEMS]: {
        title: 'returns_what_now_title_1',
        description: 'returns_what_now_text_1',
        icon: 'palette_order_return',
        activeOnStatuses: ['registered', 'package_received'],
    },
    [RETURN_STEP_RETURN_LABEL]: {
        title: 'returns_what_now_title_2',
        description: 'returns_what_now_text_2',
        icon: 'palette_label',
        activeOnStatuses: [],
    },
    [RETURN_STEP_CONTACT_US]: {
        title: 'customer.return.steps.contact_us.title',
        description: 'customer.return.steps.contact_us.description',
        icon: 'palette_phone',
        activeOnStatuses: [],
    },
    [RETURN_STEP_SEND_PARCEL]: {
        title: 'returns_what_now_title_3',
        description: 'returns_what_now_text_3',
        icon: 'palette_send',
        activeOnStatuses: [],
    },
    [RETURN_STEP_REFUND]: {
        title: 'returns_what_now_title_4',
        description: 'returns_what_now_text_4',
        icon: 'palette_refund',
        activeOnStatuses: ['returned'],
    },
};

export type { ReturnSteps, ReturnStep };

export const RETURNS_FETCH_LIMIT = 10;
